/**
 * so-v2.js - Underlinen preview, round 2 behaviours (Claude, 25 Sep 2026)
 * - hero slider: drag or swipe, arrows, dots, keyboard, autoplay with progress bar
 * - drag-to-scroll for rows ([data-drag-scroll], .so-rail, PDP stage) + icon strip arrows
 * - product page: variant-aware price, sizes, stock, images; sticky bar; complete the set
 * - ?size=S on collection pages and product pages (the always-on size S vest offer)
 * Cart, toast and drawer come from preview.js (window.SO).
 */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function inr(x) {
    var n = Math.round(Number(x) || 0), s = String(n);
    if (s.length > 3) {
      var head = s.slice(0, -3), tail = s.slice(-3), parts = [];
      while (head.length > 2) { parts.unshift(head.slice(-2)); head = head.slice(0, -2); }
      if (head) parts.unshift(head);
      s = parts.concat([tail]).join(',');
    }
    return '₹' + s;
  }
  function so() { return window.SO || {}; }
  function toast(msg) { if (so().showToast) so().showToast(msg); }
  function param(name) {
    try { return new URLSearchParams(window.location.search).get(name); } catch (e) { return null; }
  }

  // ------------------------------------------------------------ 1. hero slider
  function initHero() {
    var hero = $('[data-so-hero]');
    if (!hero) return;
    var viewport = $('.so-hero-viewport', hero);
    var track = $('.so-hero-track', hero);
    var slides = $$('.so-hero-slide', hero);
    var dots = $$('.so-slide-dot', hero);
    var counter = $('[data-hero-current]', hero);
    var bar = $('.so-hero-progress span', hero);
    var n = slides.length;
    if (!n) return;
    var cur = 0, timer = null, paused = false, DELAY = 6000;
    // video slides (size S 60%, 9 Oct): the slider waits on them until the video has ended
    var mqM = window.matchMedia ? window.matchMedia('(max-width:767px)') : null;
    var vids = slides.map(function (s) { return $('video[data-src-d]', s); });
    function vidFailed(v) {                       // autoplay blocked (e.g. iOS low power): show the offer frame, slide on normally
      v.soFailed = true;
      var sl = v.closest('.so-hero-slide');
      $$('[data-end]', sl).forEach(function (el) {
        el.setAttribute(el.tagName === 'SOURCE' ? 'srcset' : 'src', el.getAttribute('data-end'));
      });
      v.style.visibility = 'hidden';
      if (vids[cur] === v) schedule();
    }
    function vidSrc(v) {
      var want = v.getAttribute(mqM && mqM.matches ? 'data-src-m' : 'data-src-d');
      if (v.soSrc !== want) { v.soSrc = want; v.src = want; }
    }
    function vidPlay(v) {
      if (v.soFailed) return;
      vidSrc(v);
      var pr = v.play();
      if (pr && pr.catch) pr.catch(function (err) { if (err && err.name === 'NotAllowedError') vidFailed(v); });
    }
    vids.forEach(function (v) {
      if (!v) return;
      v.muted = true;
      v.addEventListener('ended', function () { if (vids[cur] === v) schedule(); });
      v.addEventListener('timeupdate', function () {
        if (vids[cur] === v && bar && v.duration) bar.style.width = (100 * v.currentTime / v.duration) + '%';
      });
      v.addEventListener('error', function () { if (!v.soFailed && v.src) vidFailed(v); });
    });
    if (mqM && mqM.addEventListener) mqM.addEventListener('change', function () {
      vids.forEach(function (v, k) { if (v && !v.soFailed) { vidSrc(v); if (k === cur) { v.currentTime = 0; vidPlay(v); } } });
    });

    function pad(i) { return (i < 9 ? '0' : '') + (i + 1); }
    function place(offsetPx, animate) {
      track.style.transition = animate ? '' : 'none';
      track.style.transform = 'translate3d(calc(' + (-cur * 100) + '% + ' + (offsetPx || 0) + 'px),0,0)';
    }
    function restartBar() {
      if (!bar) return;
      bar.style.width = '';
      bar.classList.remove('is-running');
      void bar.offsetWidth;                         // restart the CSS animation
      if (!paused && !reduceMotion) bar.classList.add('is-running');
    }
    var shown = -1;
    function go(i, animate) {
      cur = (i + n) % n;
      var fresh = cur !== shown; shown = cur;      // a cancelled swipe must not restart the video
      slides.forEach(function (s, k) {
        var on = k === cur;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        $$('a, button', s).forEach(function (el) { el.tabIndex = on ? 0 : -1; });
        var v = vids[k];
        if (v) {
          if (on && fresh) { try { v.currentTime = 0; } catch (e) {} vidPlay(v); }
          else if (!v.paused) v.pause();
        }
      });
      dots.forEach(function (d, k) { d.classList.toggle('so-dot-active', k === cur); d.setAttribute('aria-current', k === cur ? 'true' : 'false'); });
      if (counter) counter.textContent = pad(cur);
      hero.classList.toggle('so-hero--vid', !!vids[cur]);   // light film background: dark nav
      place(0, animate !== false);
      syncMobileLogos();
      schedule();
    }
    function schedule() {
      clearTimeout(timer);
      var v = vids[cur];
      if (v && !v.soFailed) {                     // hold until the video ends, then move on
        if (bar) bar.classList.remove('is-running');
        if (v.ended && !paused) timer = setTimeout(function () { go(cur + 1); }, 400);
        return;
      }
      restartBar();
      if (paused || reduceMotion) return;
      timer = setTimeout(function () { go(cur + 1); }, DELAY);
    }
    function pause(on) {
      paused = on;
      var v = vids[cur];
      if (v && !v.soFailed && !v.ended) {         // hover keeps the video running; only a hidden tab pauses it
        if (document.hidden) v.pause(); else if (v.paused) vidPlay(v);
      }
      if (on) { clearTimeout(timer); if (bar && (!v || v.soFailed)) bar.classList.remove('is-running'); }
      else schedule();
    }

    $$('[data-slide-prev]', hero).forEach(function (b) { b.addEventListener('click', function () { go(cur - 1); }); });
    $$('[data-slide-next]', hero).forEach(function (b) { b.addEventListener('click', function () { go(cur + 1); }); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
    hero.addEventListener('mouseenter', function () { pause(true); });
    hero.addEventListener('mouseleave', function () { pause(false); });
    hero.addEventListener('focusin', function () { pause(true); });
    hero.addEventListener('focusout', function (e) { if (!hero.contains(e.relatedTarget)) pause(false); });
    viewport.setAttribute('tabindex', '0');
    viewport.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
    });
    document.addEventListener('visibilitychange', function () { pause(document.hidden); });

    // drag / swipe (mouse, touch and pen through pointer events; vertical scroll still works)
    var startX = 0, startY = 0, dx = 0, dragging = false, decided = false, horizontal = false, moved = false, pid = null;
    viewport.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragging = true; decided = false; horizontal = false; moved = false;
      startX = e.clientX; startY = e.clientY; dx = 0; pid = e.pointerId;
      clearTimeout(timer);
    });
    viewport.addEventListener('pointermove', function (e) {
      if (!dragging || e.pointerId !== pid) return;
      var mx = e.clientX - startX, my = e.clientY - startY;
      if (!decided) {
        if (Math.abs(mx) < 6 && Math.abs(my) < 6) return;
        decided = true;
        horizontal = Math.abs(mx) > Math.abs(my);
        if (!horizontal) { dragging = false; schedule(); return; }
        try { viewport.setPointerCapture(pid); } catch (err) {}
        viewport.classList.add('is-dragging');
      }
      dx = mx; moved = true;
      var edge = (cur === 0 && dx > 0) || (cur === n - 1 && dx < 0);
      place(edge ? dx * 0.35 : dx, false);         // rubber band past the ends, then wrap
    });
    function end(e) {
      if (!dragging || (e && e.pointerId !== pid)) return;
      dragging = false;
      viewport.classList.remove('is-dragging');
      var w = viewport.clientWidth || 1;
      if (horizontal && Math.abs(dx) > Math.min(80, w * 0.12)) go(dx < 0 ? cur + 1 : cur - 1);
      else if (horizontal) go(cur);
      else schedule();
    }
    viewport.addEventListener('pointerup', end);
    viewport.addEventListener('pointercancel', end);
    viewport.addEventListener('lostpointercapture', function (e) { if (e.target === viewport) end(e); });
    // a drag must not open the slide's link
    viewport.addEventListener('click', function (e) {
      if (moved && Math.abs(dx) > 6) { e.preventDefault(); e.stopPropagation(); }
      moved = false;
    }, true);
    viewport.addEventListener('dragstart', function (e) { e.preventDefault(); });

    // Sync mobile logo placement: sit gracefully above the caption box with a clean gap
    function syncMobileLogos() {
      var isMobile = window.innerWidth <= 767;
      slides.forEach(function (s) {
        var lg = $('.so-hero-top-logos', s);
        var cap = $('.so-hero-cap', s);
        if (!lg) return;
        if (!isMobile) {
          lg.style.top = '';
          lg.style.bottom = '';
          lg.style.left = '';
        } else if (cap) {
          var h = cap.offsetHeight || 210;
          lg.style.top = 'auto';
          lg.style.bottom = (h + 18) + 'px';
          lg.style.left = '14px';
        }
      });
    }

    go(0, false);
    syncMobileLogos();
    window.addEventListener('resize', syncMobileLogos);
    window.addEventListener('load', syncMobileLogos);
    setTimeout(syncMobileLogos, 100);
  }

  // ------------------------------------------------------------ 2. drag to scroll (mouse)
  // nearest card edge to the current position, leaning the way the row was dragged
  function settle(row, dir) {
    var kids = row.children, max = row.scrollWidth - row.clientWidth;
    var rl = row.getBoundingClientRect().left + (parseFloat(getComputedStyle(row).paddingLeft) || 0);
    var now = row.scrollLeft, best = now, bestD = Infinity;
    for (var i = 0; i < kids.length; i++) {
      if (kids[i].offsetParent === null) continue;
      var pos = now + kids[i].getBoundingClientRect().left - rl;
      var d = Math.abs(pos - now) - (dir && (pos - now) * dir > 0 ? 40 : 0);
      if (d < bestD) { bestD = d; best = pos; }
    }
    return Math.max(0, Math.min(max, best));
  }
  function dragScroll(row) {
    if (row.__soDrag) return;
    row.__soDrag = true;
    var down = false, startX = 0, startLeft = 0, moved = 0, pid = null, lastD = 0, restore = null;
    row.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;   // touch scrolls natively
      if (row.scrollWidth <= row.clientWidth + 2) return;
      down = true; moved = 0; lastD = 0; startX = e.clientX; startLeft = row.scrollLeft; pid = e.pointerId;
    });
    row.addEventListener('pointermove', function (e) {
      if (!down || e.pointerId !== pid) return;
      var d = e.clientX - startX;
      if (!moved && Math.abs(d) < 5) return;
      if (!moved) {
        clearTimeout(restore);
        row.classList.add('is-grab');
        row.style.scrollSnapType = 'none';        // snapping and smooth scrolling fight a drag
        row.style.scrollBehavior = 'auto';
        try { row.setPointerCapture(pid); } catch (err) {}
      }
      moved = Math.max(1, Math.abs(d));
      lastD = d;
      row.scrollLeft = startLeft - d;
      e.preventDefault();
    });
    function up(e) {
      if (!down || (e && e.pointerId !== pid)) return;
      down = false;
      if (moved) {
        row.classList.remove('is-grab');
        row.style.scrollBehavior = '';
        row.scrollTo({ left: settle(row, lastD < 0 ? 1 : -1), behavior: reduceMotion ? 'auto' : 'smooth' });
        restore = setTimeout(function () { row.style.scrollSnapType = ''; }, 450);
      }
      setTimeout(function () { moved = 0; }, 0);
    }
    row.addEventListener('pointerup', up);
    row.addEventListener('pointercancel', up);
    row.addEventListener('lostpointercapture', function (e) { if (e.target === row) up(e); });
    row.addEventListener('click', function (e) { if (moved > 5) { e.preventDefault(); e.stopPropagation(); } }, true);
    row.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }
  function initDragRows() {
    $$('[data-drag-scroll], .so-rail, [data-stage]').forEach(dragScroll);
  }

  function initIconbar() {
    $$('[data-so-iconbar]').forEach(function (bar) {
      var row = $('.so-iconbar-row', bar);
      var prev = $('[data-scroll-prev]', bar), next = $('[data-scroll-next]', bar);
      if (!row) return;
      function sync() {
        if (prev) prev.disabled = row.scrollLeft <= 4;
        if (next) next.disabled = row.scrollLeft + row.clientWidth >= row.scrollWidth - 4;
      }
      function step(dir) { row.scrollBy({ left: dir * Math.max(240, row.clientWidth * 0.7), behavior: reduceMotion ? 'auto' : 'smooth' }); }
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      row.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  function initOffersRail() {
    $$('.so-promo-wrap').forEach(function (wrap) {
      var row = $('.so-promo-grid', wrap);
      var prev = $('[data-so-promo-prev]', wrap), next = $('[data-so-promo-next]', wrap);
      if (!row) return;
      function sync() {
        if (prev) {
          prev.disabled = row.scrollLeft <= 4;
          prev.style.opacity = row.scrollLeft <= 4 ? '0' : '1';
          prev.style.pointerEvents = row.scrollLeft <= 4 ? 'none' : 'auto';
        }
        if (next) {
          var atEnd = row.scrollLeft + row.clientWidth >= row.scrollWidth - 6;
          next.disabled = atEnd;
          next.style.opacity = atEnd ? '0' : '1';
          next.style.pointerEvents = atEnd ? 'none' : 'auto';
        }
      }
      function step(dir) {
        row.scrollBy({ left: dir * Math.max(260, row.clientWidth * 0.85), behavior: reduceMotion ? 'auto' : 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      row.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  // ------------------------------------------------------------ 3. product page
  function initPDP() {
    var root = $('[data-so-pdp]');
    var dataEl = document.getElementById('so-pdp-data');
    if (!root || !dataEl) return;
    var D;
    try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var V = D.variants || [];
    var stage = $('[data-stage]', root);
    var slides = $$('.so-stage-slide', root);
    var thumbs = $$('[data-thumb]', root);
    var sdots = $$('.so-stage-dot', root);
    var swatches = $$('[data-so-swatch]', root);
    var sizeBtns = $$('[data-size]', root);
    var qtyEl = $('[data-qty]', root);
    var atc = $('[data-atc]', root);
    var atcPrice = $('[data-atc-price]', root);
    var buyNow = $('[data-buy-now]', root);
    var note = $('[data-variant-note]', root);
    var sticky = $('[data-sticky-atc]');
    var stickyPrice = $('[data-sticky-price]');
    var stickyVar = $('[data-sticky-variant]');
    var stickyImg = $('[data-sticky-img]');
    var stickyAdd = $('[data-sticky-add]');

    var avail = V.filter(function (v) { return v.a; });
    // open on the colour the gallery photos belong to (slide 0), so label and picture match
    var galleryFirst = D.hasColour ? avail.filter(function (v) { return v.i === 0; })[0] : null;
    var first = galleryFirst || avail[0] || V[0] || {};
    var sel = { c: first.c || '', s: first.s || '' };
    var imgIndex = 0;

    function pretty(c) {
      if (!c) return '';
      var t = c === c.toUpperCase() ? c.toLowerCase().replace(/\b\w/g, function (m) { return m.toUpperCase(); }) : c;
      return t.replace(/\bPuma\b/g, 'PUMA').replace(/\bFcuk\b/g, 'FCUK');
    }
    function match(c, s) {
      return V.filter(function (v) { return (!D.hasColour || v.c === c) && (!D.hasSize || v.s === s); })[0] || null;
    }
    function current() { return match(sel.c, sel.s); }

    // gallery
    function showImage(i, smooth) {
      if (!slides.length) return;
      imgIndex = Math.max(0, Math.min(slides.length - 1, i));
      if (stage) stage.scrollTo({ left: stage.clientWidth * imgIndex, behavior: smooth === false || reduceMotion ? 'auto' : 'smooth' });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === imgIndex); });
      sdots.forEach(function (d, k) { d.classList.toggle('is-on', k === imgIndex); });
      var th = thumbs[imgIndex];
      if (th && th.parentNode && th.parentNode.scrollHeight > th.parentNode.clientHeight) {
        th.parentNode.scrollTop = th.offsetTop - th.parentNode.clientHeight / 2 + th.clientHeight / 2;
      }
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showImage(Number(t.getAttribute('data-thumb'))); }); });
    var prevB = $('[data-stage-prev]', root), nextB = $('[data-stage-next]', root);
    if (prevB) prevB.addEventListener('click', function () { showImage(imgIndex > 0 ? imgIndex - 1 : slides.length - 1); });
    if (nextB) nextB.addEventListener('click', function () { showImage(imgIndex < slides.length - 1 ? imgIndex + 1 : 0); });
    if (stage) {
      var st = null;
      stage.addEventListener('scroll', function () {
        clearTimeout(st);
        st = setTimeout(function () {
          var i = Math.round(stage.scrollLeft / Math.max(1, stage.clientWidth));
          if (i !== imgIndex) {
            imgIndex = i;
            thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
            sdots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
          }
        }, 90);
      }, { passive: true });
      stage.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') showImage(imgIndex - 1);
        if (e.key === 'ArrowRight') showImage(imgIndex + 1);
      });
    }

    // --- Colour image fallback -------------------------------------------------
    // The static build bakes only the first colour's photos into the gallery
    // (images[:10]); a variant whose photo sits past that cap -- or whose
    // featured image isn't in the gallery at all (v.i === -1) -- has no slide to
    // switch to, so clicking its swatch used to leave the main image unchanged.
    // Each swatch still carries that colour's own hero photo, so fall back to it.
    var swatchHero = {};
    swatches.forEach(function (b) {
      var c = b.getAttribute('data-so-swatch');
      var bg = b.style.backgroundImage || '';
      var m = bg.match(/url\(\s*['"]?([^'")]+)['"]?\s*\)/);
      if (c && m) swatchHero[c] = m[1].split('?')[0];
    });
    var baseSlideImg = slides[0] ? $('img', slides[0]) : null;
    var baseThumbImg = thumbs[0] ? $('img', thumbs[0]) : null;
    var baseHeroSrc = baseSlideImg ? (baseSlideImg.getAttribute('src') || '') : '';
    var baseHeroSet = baseSlideImg ? (baseSlideImg.getAttribute('srcset') || '') : '';
    var baseThumbSrc = baseThumbImg ? (baseThumbImg.getAttribute('src') || '') : '';

    function colourInGallery(v) { return !!v && v.i >= 0 && v.i < slides.length; }

    // Paint the gallery for the chosen colour. single=false restores the baked
    // multi-photo gallery (base colour, or any colour whose photo is in it);
    // single=true shows just that colour's hero photo and hides the leftover
    // base-colour slides so nothing off-colour is on screen.
    function setGallery(single, hero) {
      if (single && hero) {
        if (baseSlideImg) {
          baseSlideImg.setAttribute('src', hero + '?width=900');
          baseSlideImg.setAttribute('srcset', hero + '?width=600 600w, ' + hero + '?width=900 900w, ' + hero + '?width=1200 1200w');
        }
        if (baseThumbImg) baseThumbImg.setAttribute('src', hero + '?width=160');
      } else {
        if (baseSlideImg) {
          baseSlideImg.setAttribute('src', baseHeroSrc);
          if (baseHeroSet) baseSlideImg.setAttribute('srcset', baseHeroSet);
        }
        if (baseThumbImg && baseThumbSrc) baseThumbImg.setAttribute('src', baseThumbSrc);
      }
      slides.forEach(function (s, k) { if (k > 0) s.style.display = single ? 'none' : ''; });
      thumbs.forEach(function (t, k) { if (k > 0) t.style.display = single ? 'none' : ''; });
      sdots.forEach(function (d, k) { if (k > 0) d.style.display = single ? 'none' : ''; });
    }

    // Lightbox & Zoom Integration (Leo, Sep 2026)
    (function initLightbox() {
      var stageWrap = $('.so-stage-wrap', root) || (stage ? stage.parentElement : null);
      if (!stageWrap || !slides.length) return;

      var slideImgs = [];
      function buildSlideImgs() {
        slideImgs = [];
        slides.forEach(function (slide, idx) {
          if (slide.style.display === 'none') return;   // a colour selection collapsed this slide
          var im = $('img', slide);
          if (im) {
            var src = (im.getAttribute('src') || '').trim();
            var hiRes = src;
            if (src.indexOf('cdn.shopify.com') !== -1) {
              hiRes = src.replace(/(\?|&)width=\d+/, '$1width=2000');
              if (hiRes === src) hiRes = src + (src.indexOf('?') !== -1 ? '&width=2000' : '?width=2000');
            }
            slideImgs.push({
              src: src,
              hiRes: hiRes,
              alt: im.getAttribute('alt') || 'Product image ' + (idx + 1)
            });
          }
        });
      }
      buildSlideImgs();
      if (!slideImgs.length) return;

      // Add floating zoom button to stage wrap if not present
      if (!stageWrap.querySelector('.so-stage-zoom-btn')) {
        var zoomBtn = document.createElement('button');
        zoomBtn.type = 'button';
        zoomBtn.className = 'so-stage-zoom-btn';
        zoomBtn.setAttribute('aria-label', 'Open fullscreen image lightbox and zoom');
        zoomBtn.setAttribute('title', 'Click to open lightbox & zoom');
        zoomBtn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line><line x1="11" y1="8" x2="11" y2="14"></line><line x1="8" y1="11" x2="14" y2="11"></line></svg>';
        stageWrap.appendChild(zoomBtn);
        zoomBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          openLightbox(imgIndex);
        });
      }

      // Clicking main stage slide opens lightbox
      slides.forEach(function (slide, idx) {
        slide.style.cursor = 'zoom-in';
        slide.addEventListener('click', function (e) {
          if (e.target.closest('.so-stage-arrow') || e.target.closest('.so-stage-dots')) return;
          openLightbox(idx);
        });
      });

      // Inject / Retrieve Lightbox element
      var lb = document.getElementById('so-lightbox');
      if (!lb) {
        lb = document.createElement('div');
        lb.id = 'so-lightbox';
        lb.className = 'so-lightbox';
        lb.setAttribute('role', 'dialog');
        lb.setAttribute('aria-label', 'Product Image Lightbox and Zoom');
        lb.setAttribute('aria-hidden', 'true');
        lb.innerHTML = [
          '<div class="so-lb-header">',
          '  <span class="so-lb-counter" id="so-lb-counter">01 / 01</span>',
          '  <div class="so-lb-actions">',
          '    <button type="button" class="so-lb-btn" id="so-lb-zoom-out" title="Zoom out (-)" aria-label="Zoom out"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><line x1="5" y1="12" x2="19" y2="12"></line></svg></button>',
          '    <button type="button" class="so-lb-btn" id="so-lb-zoom-in" title="Zoom in (+)" aria-label="Zoom in"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg></button>',
          '    <button type="button" class="so-lb-btn" id="so-lb-reset" title="Reset zoom (0)" aria-label="Reset zoom"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="1 4 1 10 7 10"></polyline><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path></svg></button>',
          '    <button type="button" class="so-lb-btn" id="so-lb-close" title="Close (Esc)" aria-label="Close lightbox"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></button>',
          '  </div>',
          '</div>',
          '<div class="so-lb-viewport" id="so-lb-viewport">',
          '  <button type="button" class="so-lb-nav is-prev" id="so-lb-prev" aria-label="Previous photo">&#8249;</button>',
          '  <div class="so-lb-stage" id="so-lb-stage">',
          '    <img id="so-lb-img" src="" alt="Product zoom" draggable="false" />',
          '  </div>',
          '  <button type="button" class="so-lb-nav is-next" id="so-lb-next" aria-label="Next photo">&#8250;</button>',
          '</div>',
          '<div class="so-lb-footer">',
          '  <div class="so-lb-thumbs" id="so-lb-thumbs"></div>',
          '</div>'
        ].join('');
        document.body.appendChild(lb);
      }

      var lbImg = document.getElementById('so-lb-img');
      var lbStage = document.getElementById('so-lb-stage');
      var lbViewport = document.getElementById('so-lb-viewport');
      var lbCounter = document.getElementById('so-lb-counter');
      var lbThumbs = document.getElementById('so-lb-thumbs');
      var lbPrev = document.getElementById('so-lb-prev');
      var lbNext = document.getElementById('so-lb-next');
      var lbClose = document.getElementById('so-lb-close');
      var lbZoomIn = document.getElementById('so-lb-zoom-in');
      var lbZoomOut = document.getElementById('so-lb-zoom-out');
      var lbReset = document.getElementById('so-lb-reset');

      var lbIndex = 0;
      var scale = 1;
      var posX = 0, posY = 0;
      var isDragging = false;
      var startMouseX = 0, startMouseY = 0;
      var startPosX = 0, startPosY = 0;
      var hasDragged = false;

      function updateTransform() {
        if (scale <= 1) {
          scale = 1;
          posX = 0;
          posY = 0;
          if (lbStage) {
            lbStage.classList.remove('is--zoomed');
            lbStage.style.cursor = 'zoom-in';
          }
        } else {
          if (lbStage) {
            lbStage.classList.add('is--zoomed');
            lbStage.style.cursor = isDragging ? 'grabbing' : 'grab';
          }
        }
        if (scale > 1 && lbImg && lbViewport) {
          var rect = lbImg.getBoundingClientRect();
          var maxPanX = Math.max(0, (rect.width * scale - lbViewport.clientWidth) / 2 + 100);
          var maxPanY = Math.max(0, (rect.height * scale - lbViewport.clientHeight) / 2 + 100);
          posX = Math.max(-maxPanX, Math.min(maxPanX, posX));
          posY = Math.max(-maxPanY, Math.min(maxPanY, posY));
        }
        if (lbImg) {
          lbImg.style.transform = 'translate3d(' + posX + 'px, ' + posY + 'px, 0) scale(' + scale + ')';
        }
      }

      function setScale(newScale, smooth) {
        scale = Math.max(1, Math.min(3.5, Math.round(newScale * 100) / 100));
        if (scale === 1) { posX = 0; posY = 0; }
        if (smooth !== false && lbImg) {
          lbImg.style.transition = 'transform 0.22s cubic-bezier(0.2, 0.8, 0.2, 1)';
          setTimeout(function () { if (lbImg) lbImg.style.transition = ''; }, 240);
        }
        updateTransform();
      }

      function renderThumbs() {
        if (!lbThumbs) return;
        lbThumbs.innerHTML = '';
        slideImgs.forEach(function (item, idx) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'so-lb-thumb' + (idx === lbIndex ? ' is-active' : '');
          btn.setAttribute('aria-label', 'View photo ' + (idx + 1));
          var tImg = document.createElement('img');
          tImg.src = item.src;
          tImg.alt = item.alt;
          btn.appendChild(tImg);
          btn.addEventListener('click', function (e) {
            e.stopPropagation();
            setLbImage(idx);
          });
          lbThumbs.appendChild(btn);
        });
        scrollActiveThumb();
      }

      function scrollActiveThumb() {
        var active = lbThumbs ? lbThumbs.querySelector('.so-lb-thumb.is-active') : null;
        if (active && lbThumbs) {
          lbThumbs.scrollTo({
            left: active.offsetLeft - lbThumbs.clientWidth / 2 + active.clientWidth / 2,
            behavior: 'smooth'
          });
        }
      }

      function setLbImage(idx) {
        if (!slideImgs.length) return;
        lbIndex = (idx + slideImgs.length) % slideImgs.length;
        scale = 1;
        posX = 0;
        posY = 0;
        updateTransform();

        var cur = slideImgs[lbIndex];
        if (lbImg) {
          lbImg.src = cur.src;
          lbImg.alt = cur.alt;
          if (cur.hiRes && cur.hiRes !== cur.src) {
            var hi = new Image();
            var targetIdx = lbIndex;
            hi.onload = function () {
              if (lbIndex === targetIdx && lbImg) {
                lbImg.src = cur.hiRes;
              }
            };
            hi.src = cur.hiRes;
          }
        }
        if (lbCounter) {
          var num = (lbIndex + 1 < 10 ? '0' : '') + (lbIndex + 1);
          var tot = (slideImgs.length < 10 ? '0' : '') + slideImgs.length;
          lbCounter.textContent = num + ' / ' + tot;
        }
        if (lbThumbs) {
          var allT = lbThumbs.querySelectorAll('.so-lb-thumb');
          allT.forEach(function (th, k) {
            th.classList.toggle('is-active', k === lbIndex);
          });
          scrollActiveThumb();
        }
        showImage(lbIndex, false);
      }

      function openLightbox(idx) {
        buildSlideImgs();                               // reflect the colour currently on screen
        if (!slideImgs.length) return;
        lbIndex = typeof idx === 'number' ? idx : imgIndex;
        if (lbIndex >= slideImgs.length) lbIndex = 0;
        renderThumbs();
        setLbImage(lbIndex);
        lb.classList.add('is--open');
        lb.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }

      function closeLightbox() {
        lb.classList.remove('is--open');
        lb.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        scale = 1;
        posX = 0;
        posY = 0;
        updateTransform();
        showImage(lbIndex, false);
      }

      // Event Listeners for Lightbox Controls
      if (lbClose) lbClose.onclick = function (e) { e.stopPropagation(); closeLightbox(); };
      if (lbZoomIn) lbZoomIn.onclick = function (e) { e.stopPropagation(); setScale(scale + 0.5); };
      if (lbZoomOut) lbZoomOut.onclick = function (e) { e.stopPropagation(); setScale(scale - 0.5); };
      if (lbReset) lbReset.onclick = function (e) { e.stopPropagation(); setScale(1); };
      if (lbPrev) lbPrev.onclick = function (e) { e.stopPropagation(); setLbImage(lbIndex - 1); };
      if (lbNext) lbNext.onclick = function (e) { e.stopPropagation(); setLbImage(lbIndex + 1); };

      // Click on image toggles zoom (1x <-> 2.25x)
      if (lbStage) {
        lbStage.addEventListener('click', function (e) {
          if (hasDragged) { hasDragged = false; return; }
          if (e.target === lbImg || e.target === lbStage) {
            if (scale === 1) {
              setScale(2.25);
            } else {
              setScale(1);
            }
          }
        });

        // Mouse Wheel Zoom
        lbStage.addEventListener('wheel', function (e) {
          e.preventDefault();
          var delta = e.deltaY < 0 ? 0.3 : -0.3;
          setScale(scale + delta, false);
        }, { passive: false });

        // Pan / Drag Handling
        var startPointer = function (clientX, clientY) {
          isDragging = true;
          hasDragged = false;
          startMouseX = clientX;
          startMouseY = clientY;
          startPosX = posX;
          startPosY = posY;
          if (lbStage) lbStage.classList.add('is--dragging');
        };

        var movePointer = function (clientX, clientY) {
          if (!isDragging) return;
          var dx = clientX - startMouseX;
          var dy = clientY - startMouseY;
          if (Math.abs(dx) > 4 || Math.abs(dy) > 4) hasDragged = true;
          if (scale > 1) {
            posX = startPosX + dx;
            posY = startPosY + dy;
            updateTransform();
          }
        };

        var endPointer = function (clientX) {
          if (!isDragging) return;
          isDragging = false;
          if (lbStage) lbStage.classList.remove('is--dragging');
          // If scale == 1 and dragged horizontally > 50px, change image
          if (scale === 1 && hasDragged && typeof clientX === 'number') {
            var diff = clientX - startMouseX;
            if (diff > 50) setLbImage(lbIndex - 1);
            else if (diff < -50) setLbImage(lbIndex + 1);
          }
          if (scale > 1) updateTransform();
        };

        lbStage.addEventListener('mousedown', function (e) {
          if (e.button !== 0) return;
          e.preventDefault();
          startPointer(e.clientX, e.clientY);
        });
        window.addEventListener('mousemove', function (e) {
          if (isDragging) movePointer(e.clientX, e.clientY);
        });
        window.addEventListener('mouseup', function (e) {
          if (isDragging) endPointer(e.clientX);
        });

        // Touch support
        lbStage.addEventListener('touchstart', function (e) {
          if (e.touches.length === 1) {
            startPointer(e.touches[0].clientX, e.touches[0].clientY);
          }
        }, { passive: true });
        lbStage.addEventListener('touchmove', function (e) {
          if (isDragging && e.touches.length === 1) {
            movePointer(e.touches[0].clientX, e.touches[0].clientY);
          }
        }, { passive: true });
        lbStage.addEventListener('touchend', function (e) {
          if (isDragging) {
            var cx = e.changedTouches && e.changedTouches[0] ? e.changedTouches[0].clientX : null;
            endPointer(cx);
          }
        });
      }

      // Close when clicking empty dark area outside stage
      if (lbViewport) {
        lbViewport.addEventListener('click', function (e) {
          if (e.target === lbViewport && scale === 1) {
            closeLightbox();
          }
        });
      }

      // Global keyboard navigation
      document.addEventListener('keydown', function (e) {
        if (!lb.classList.contains('is--open')) return;
        if (e.key === 'Escape') {
          closeLightbox();
        } else if (e.key === 'ArrowLeft') {
          setLbImage(lbIndex - 1);
        } else if (e.key === 'ArrowRight') {
          setLbImage(lbIndex + 1);
        } else if (e.key === '+' || e.key === '=') {
          setScale(scale + 0.5);
        } else if (e.key === '-' || e.key === '_') {
          setScale(scale - 0.5);
        } else if (e.key === '0') {
          setScale(1);
        }
      });
    })();

    // price, stock, labels
    function render(opts) {
      var v = current();
      // size buttons follow the selected colour
      sizeBtns.forEach(function (b) {
        var s = b.getAttribute('data-size');
        var mv = match(sel.c, s);
        b.classList.toggle('is-on', s === sel.s);
        b.classList.toggle('is-out', !mv || !mv.a);
        b.setAttribute('aria-pressed', s === sel.s ? 'true' : 'false');
        b.title = !mv ? 'Not made in this colour' : (!mv.a ? 'Sold out in this colour' : '');
      });
      swatches.forEach(function (b) {
        var on = b.getAttribute('data-so-swatch') === sel.c;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var cl = $('[data-colour-label]', root); if (cl) cl.textContent = pretty(sel.c);
      var sl = $('[data-size-label]', root); if (sl) sl.textContent = sel.s || '';

      var nowEl = $('[data-price-now]', root), wasEl = $('[data-price-was]', root);
      var offEl = $('[data-price-off]', root), saveEl = $('[data-price-save]', root);
      var flag = $('[data-flag-off]', root);
      if (!v) {
        if (note) { note.textContent = 'This colour is not made in size ' + sel.s + '. Pick another size.'; note.className = 'so-varnote is-out'; }
        if (atc) atc.disabled = true;
        if (stickyAdd) stickyAdd.disabled = true;
        return;
      }
      var off = v.cp ? Math.round((1 - v.p / v.cp) * 100) : 0;
      if (nowEl) nowEl.textContent = inr(v.p);
      if (wasEl) { wasEl.textContent = v.cp ? inr(v.cp) : ''; wasEl.hidden = !v.cp; }
      if (offEl) { offEl.textContent = off + '% OFF'; offEl.hidden = !off; }
      if (flag) { flag.textContent = off + '% off'; flag.hidden = !off; }
      if (saveEl) {
        var parts = [];
        if (v.cp) parts.push('You save ' + inr(v.cp - v.p));
        if (D.pack > 1) parts.push('<span class="so-pp">about ' + inr(v.p / D.pack) + ' per piece</span>');
        saveEl.innerHTML = parts.join(' · ');
      }
      if (atcPrice) atcPrice.textContent = inr(v.p);
      if (stickyPrice) stickyPrice.textContent = inr(v.p);
      if (stickyVar) stickyVar.textContent = [pretty(sel.c), sel.s ? 'Size ' + sel.s : ''].filter(Boolean).join(' · ');
      if (atc) atc.disabled = !v.a;
      if (stickyAdd) stickyAdd.disabled = !v.a;
      if (atc) atc.firstChild.textContent = v.a ? 'Add to cart · ' : 'Sold out · ';
      if (note) {
        if (!v.a) { note.textContent = 'Sold out in this ' + (D.hasSize ? 'size' : 'colour') + '. Try another one.'; note.className = 'so-varnote is-out'; }
        else if (v.o === 's_vest') { note.textContent = 'Size S offer: ' + D.sOffer + '% off this size.'; note.className = 'so-varnote is-offer'; }
        else { note.textContent = ''; note.className = 'so-varnote'; }
      }
      if (opts && opts.image) {
        if (colourInGallery(v)) {
          setGallery(false);                            // this colour's photo is baked in -> native gallery
          showImage(v.i, opts.smooth);
          if (stickyImg && slides[v.i]) {
            var im = $('img', slides[v.i]);
            if (im) stickyImg.src = (im.getAttribute('src') || '').split('?')[0] + '?width=120';
          }
        } else if (D.hasColour && sel.c) {
          var hero = swatchHero[sel.c] || baseHeroSrc.split('?')[0];
          setGallery(true, hero);                       // not baked in -> show the swatch's own hero photo
          showImage(0, opts.smooth);
          if (stickyImg && hero) stickyImg.src = hero + '?width=120';
        }
      }
    }

    swatches.forEach(function (b) {
      b.addEventListener('click', function () {
        sel.c = b.getAttribute('data-so-swatch');
        // keep the size if this colour has it in stock, else move to the first in-stock size
        var keep = match(sel.c, sel.s);
        if (D.hasSize && (!keep || !keep.a)) {
          var alt = V.filter(function (v) { return v.c === sel.c && v.a; })[0];
          if (alt) sel.s = alt.s;
        }
        render({ image: true });
      });
    });
    sizeBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        sel.s = b.getAttribute('data-size');
        render({ image: false });
      });
    });

    // quantity
    var qty = 1;
    function setQty(q) { qty = Math.max(1, Math.min(20, q)); if (qtyEl) qtyEl.value = qty; }
    var minus = $('[data-qty-minus]', root), plus = $('[data-qty-plus]', root);
    if (minus) minus.addEventListener('click', function () { setQty(qty - 1); });
    if (plus) plus.addEventListener('click', function () { setQty(qty + 1); });

    function add(q, opts) {
      var v = current();
      if (!v || !v.a) { toast('Pick an available size first.'); return false; }
      var im = slides[v.i >= 0 ? v.i : 0] ? $('img', slides[v.i >= 0 ? v.i : 0]) : null;
      if (so().addToCart) {
        so().addToCart({
          handle: D.handle, title: D.title, price: inr(v.p), color: pretty(v.c), size: v.s || 'One size',
          image: im ? (im.getAttribute('src') || '').split('?')[0] + '?width=240' : '', qty: q || qty
        }, opts);
      }
      return true;
    }
    if (atc) atc.addEventListener('click', function () { add(qty); });
    if (stickyAdd) stickyAdd.addEventListener('click', function () { add(1); });
    if (buyNow) buyNow.addEventListener('click', function () {
      var v = current();
      if (!v || !v.a) { toast('Pick an available size first.'); return; }
      if (so().addToCart) {
        so().addToCart({
          handle: D.handle, title: D.title, price: inr(v.p), color: pretty(v.c),
          size: v.s || 'One size', image: '', qty: qty
        }, { silent: true, thenCheckout: true });
      }
    });

    // sticky bar shows once the main button has scrolled above the screen
    // (a scroll check, not an IntersectionObserver: a jump straight past the button fires no IO event)
    if (sticky && atc) {
      var ticking = false;
      var syncSticky = function () {
        ticking = false;
        var show = atc.getBoundingClientRect().bottom < 0;
        if (show !== sticky.classList.contains('is-show')) {
          sticky.classList.toggle('is-show', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        }
      };
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(syncSticky); } }, { passive: true });
      window.addEventListener('resize', syncSticky);
      syncSticky();
    }

    // complete the set: add all
    var setAdd = $('[data-set-add]');
    if (setAdd) setAdd.addEventListener('click', function () {
      if (!so().addToCart) return;
      if (!add(1, { silent: true })) return;       // this piece needs a size first
      var items = $$('[data-set-item]').slice(1);
      items.forEach(function (it) {
        so().addToCart({
          handle: it.getAttribute('data-handle'), title: it.getAttribute('data-title'),
          price: inr(it.getAttribute('data-price')), color: '', size: 'Pick your size',
          image: it.getAttribute('data-img'), qty: 1
        }, { silent: true });
      });
      if (so().openDrawer) so().openDrawer('#t4s-mini_cart');   // the bag itself is the confirmation
    });

    // ?size=S (size S vest offer links) and ?colour=
    var wantS = param('size'), wantC = param('colour') || param('color');
    if (wantC) {
      var cm = V.filter(function (v) { return v.c.toLowerCase() === wantC.toLowerCase(); })[0];
      if (cm) sel.c = cm.c;
    }
    if (wantS && D.hasSize) {
      var ok = match(sel.c, wantS);
      if (!ok || !ok.a) {
        var alt = V.filter(function (v) { return v.s === wantS && v.a; })[0] || V.filter(function (v) { return v.s === wantS; })[0];
        if (alt) { sel.c = alt.c || sel.c; }
      }
      if (V.some(function (v) { return v.s === wantS; })) sel.s = wantS;
    }
    render({ image: !!(wantS || wantC) || (D.hasColour && swatches.length > 1), smooth: false });
  }

  // ------------------------------------------------------------ 4. ?size=S on collection pages
  // ------------------------------------------------------------ Wishlist
  // Logged out: hearts and the Wishlist link prompt a login (the tapped item is saved
  // once they come back). Logged in: hearts toggle, and the Wishlist link opens a panel.
  // Saved handles live in this browser, per customer (window.SO_CUSTOMER from the layout).
  var WL = (function () {
    var cid = window.SO_CUSTOMER || null;
    var KEY = 'so_wl_' + cid;
    var PENDING = 'so_wl_pending';
    function read(k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } }
    function write(k, v) { try { if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
    function list() { return (cid && read(KEY)) || []; }
    function has(h) { return list().indexOf(h) !== -1; }
    function save(arr) { write(KEY, arr); paint(); }
    function toggle(h) {
      var arr = list();
      var i = arr.indexOf(h);
      if (i === -1) arr.unshift(h); else arr.splice(i, 1);
      save(arr);   // the filled / empty heart is the feedback (no toast, 10 Oct)
    }
    function paint() {
      $$('[data-replace-wishlist]').forEach(function (b) {
        var on = has(handleOf(b));
        b.classList.toggle('is-saved', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
      });
    }
    function handleOf(el) {
      var card = el.closest('[data-so-card], [data-so-rail-card]');
      if (card) return card.getAttribute('data-so-card') || card.getAttribute('data-so-rail-card');
      var m = location.pathname.match(/\/products\/([^/?#]+)/);
      return m ? m[1] : '';
    }
    function loginUrl() { return '/customer_authentication/login?return_to=' + encodeURIComponent(location.pathname + location.search); }

    function promptLogin(h) {
      if (h) write(PENDING, h);
      var m = $('#so-wl-login');
      if (!m) {
        m = document.createElement('div');
        m.id = 'so-wl-login';
        m.className = 'so-wl-modal';
        m.setAttribute('role', 'dialog');
        m.setAttribute('aria-modal', 'true');
        m.setAttribute('aria-labelledby', 'so-wl-login-t');
        m.innerHTML = '<div class="so-wl-box">' +
          '<button type="button" class="so-wl-x" data-wl-close aria-label="Close">&times;</button>' +
          '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#111" stroke-width="1.8"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>' +
          '<h3 id="so-wl-login-t">Log in to access your wishlist</h3>' +
          '<p>Save the pieces you like and come back to them anytime.</p>' +
          '<a class="so-wl-btn" data-wl-login href="#">Log in</a>' +
          '<button type="button" class="so-wl-later" data-wl-close>Not now</button>' +
          '</div>';
        document.body.appendChild(m);
        m.addEventListener('click', function (e) {
          if (e.target === m || e.target.closest('[data-wl-close]')) { e.preventDefault(); closeModal(); }
        });
      }
      $('[data-wl-login]', m).setAttribute('href', loginUrl());
      m.classList.add('is-open');
      document.documentElement.classList.add('so-wl-lock');
      setTimeout(function () { var b = $('[data-wl-login]', m); if (b) b.focus(); }, 50);
    }
    function closeModal() {
      $$('.so-wl-modal.is-open, .so-wl-panel.is-open').forEach(function (x) { x.classList.remove('is-open'); });
      document.documentElement.classList.remove('so-wl-lock');
      if (!$('#so-wl-login.is-open')) write(PENDING, null);
    }

    function openPanel() {
      var p = $('#so-wl-panel');
      if (!p) {
        p = document.createElement('div');
        p.id = 'so-wl-panel';
        p.className = 'so-wl-panel so-wl-modal';
        p.setAttribute('role', 'dialog');
        p.setAttribute('aria-modal', 'true');
        p.setAttribute('aria-label', 'Your wishlist');
        p.innerHTML = '<aside class="so-wl-side"><div class="so-wl-head"><h3>Your wishlist</h3>' +
          '<button type="button" class="so-wl-x" data-wl-close aria-label="Close">&times;</button></div>' +
          '<div class="so-wl-items"></div></aside>';
        document.body.appendChild(p);
        p.addEventListener('click', function (e) {
          var rm = e.target.closest('[data-wl-remove]');
          if (rm) {
            e.preventDefault();
            var arr = list();
            arr.splice(arr.indexOf(rm.getAttribute('data-wl-remove')), 1);
            save(arr);
            renderPanel();
            return;
          }
          if (e.target === p || e.target.closest('[data-wl-close]')) { e.preventDefault(); closeModal(); }
        });
      }
      renderPanel();
      p.classList.add('is-open');
      document.documentElement.classList.add('so-wl-lock');
    }
    function renderPanel() {
      var box = $('#so-wl-panel .so-wl-items');
      if (!box) return;
      var arr = list();
      if (!arr.length) {
        box.innerHTML = '<p class="so-wl-empty">Your wishlist is empty.<br>Tap the heart on any product to save it here.</p>';
        return;
      }
      box.innerHTML = arr.map(function (h) { return '<div class="so-wl-row" data-wl-row="' + h + '"><span class="so-wl-ph"></span><div class="so-wl-info"><span class="so-wl-load">Loading…</span></div></div>'; }).join('');
      arr.forEach(function (h) {
        fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (pr) {
          var row = $('[data-wl-row="' + h + '"]', box);
          if (!row) return;
          var img = pr.featured_image ? String(pr.featured_image).split('?')[0] + '?width=160' : '';
          var avail = pr.available;
          row.innerHTML = '<a class="so-wl-img" href="/products/' + h + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</a>' +
            '<div class="so-wl-info"><a class="so-wl-title" href="/products/' + h + '">' + pr.title + '</a>' +
            '<span class="so-wl-price">' + inr(pr.price / 100) + (avail ? '' : ' · <em>Sold out</em>') + '</span>' +
            '<a class="so-wl-view" href="/products/' + h + '">View product</a></div>' +
            '<button type="button" class="so-wl-rm" data-wl-remove="' + h + '" aria-label="Remove">&times;</button>';
        }).catch(function () {
          var row = $('[data-wl-row="' + h + '"]', box);
          if (row) row.remove();
        });
      });
    }

    // capture phase on window so this runs before the older chrome script's wishlist toast
    window.addEventListener('click', function (e) {
      var heart = e.target.closest && e.target.closest('[data-replace-wishlist]');
      var link = !heart && e.target.closest('[data-link-wishlist], .t4s-toolbart-wish');
      if (!heart && !link) return;
      e.preventDefault();
      e.stopPropagation();
      if (!cid) { promptLogin(heart ? handleOf(heart) : null); return; }
      if (heart) toggle(handleOf(heart)); else openPanel();
    }, true);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });

    // (10 Oct) no toast on Account / sign-in links any more: the link just navigates.

    function init() {
      var pending = read(PENDING);
      if (cid && pending) {
        write(PENDING, null);
        if (!has(pending)) { var arr = list(); arr.unshift(pending); write(KEY, arr); toast('Saved to your wishlist'); }
      }
      paint();
    }
    return { init: init, paint: paint };
  })();

  // PDP delivery estimate: the snippet ships a fixed date, so work it out from today.
  // Bengaluru (56xxxx) 3 business days, rest of India 7 (the "2 to 7 business days" promise).
  function initDelivery() {
    var input = $('#so-pincode-input');
    var btn = $('#so-pincode-btn');
    var status = $('#so-delivery-status');
    if (!input || !btn || !status) return;
    var tick = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"></polyline></svg>';
    var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var DAY = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    function addBusinessDays(n) {
      var d = new Date();
      while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0) n--; }
      return d;
    }
    function check() {
      var pin = (input.value || '').replace(/\D/g, '');
      input.value = pin;
      status.classList.remove('is-error');
      if (!/^[1-9]\d{5}$/.test(pin)) {
        status.classList.add('is-error');
        status.innerHTML = '<span>Enter a valid 6-digit pincode</span>';
        return;
      }
      try { localStorage.setItem('so_pincode', pin); } catch (e) {}
      var d = addBusinessDays(pin.indexOf('56') === 0 ? 3 : 7);
      status.innerHTML = tick + '<span class="so-dl-txt">Delivery by <b>' + DAY[d.getDay()] + ', ' + d.getDate() + ' ' + MON[d.getMonth()] + '</b></span>' +
        '<span class="so-dl-free">FREE DELIVERY</span>';
    }
    try { var saved = localStorage.getItem('so_pincode'); if (saved) input.value = saved; } catch (e) {}
    input.setAttribute('inputmode', 'numeric');
    input.setAttribute('maxlength', '6');
    btn.addEventListener('click', check);
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); check(); } });
    check();
  }

  function initCollectionSize() {
    var want = param('size');
    if (!want || !$('[data-so-grid]')) return;
    var boxes = $$('.so-filter-checkbox[data-filter-group="size"]').filter(function (cb) { return cb.value.toLowerCase() === want.toLowerCase(); });
    if (!boxes.length) return;
    boxes.forEach(function (cb) { cb.checked = true; });
    boxes[0].dispatchEvent(new Event('change', { bubbles: true }));
  }

  // ------------------------------------------------------------ 5. brand video spotlight
  function initVideoSpotlight() {
    var muteBtns = $$('[data-video-mute]');
    muteBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var card = btn.closest('.so-hero-video-card') || btn.closest('.so-video-media-wrap') || btn.closest('[data-so-spotlight]') || btn.closest('.so-video-wrap') || btn.closest('.so-about');
        var video = card ? $('video', card) : $('video');
        if (!video) return;
        video.muted = !video.muted;
        var muteIc = $('.so-ic-mute, .is-muted', btn);
        var unmuteIc = $('.so-ic-unmute, .is-unmuted', btn);
        if (muteIc && unmuteIc) {
          muteIc.style.display = video.muted ? '' : 'none';
          unmuteIc.style.display = video.muted ? 'none' : '';
        }
      });
    });
  }

  // ------------------------------------------------------------ 6. bespoke feature icons
  function initFeatureIcons() {
    var ICONS = {
      cotton: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 19c0-8 5-14 15-14 0 10-6 15-14 15"/><path d="M5 19l7-7"/></svg>',
      reach: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.38 3.46L16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.5a2 2 0 0 0 2 1.67h1.14v10a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-10h1.14a2 2 0 0 0 2-1.67l.58-3.5a2 2 0 0 0-1.34-2.23z"/></svg>',
      versatile: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/></svg>',
      layer: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="3" width="13" height="13" rx="2"/><rect x="8" y="8" width="13" height="13" rx="2" opacity="0.6"/></svg>',
      effortless: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z"/><line x1="16" y1="8" x2="2" y2="22"/></svg>',
      waistband: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="2" y="6" width="20" height="12" rx="3"/><line x1="8" y1="6" x2="8" y2="18"/><line x1="16" y1="6" x2="16" y2="18"/></svg>',
      breathe: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9.59 4.59A2 2 0 1 1 11 8H2m10.59 11.41A2 2 0 1 0 14 16H2m15.73-8.27A2.5 2.5 0 1 1 19.5 12H2"/></svg>',
      freedom: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 3 21 3 21 9"/><polyline points="9 21 3 21 3 15"/><polyline points="21 15 21 21 15 21"/><polyline points="3 9 3 3 9 3"/></svg>',
      sleep: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>',
      comfort: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/></svg>',
      shoe: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>',
      style: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>',
      value: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><circle cx="7" cy="7" r="1.5"/></svg>',
      stability: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="5" r="3"/><line x1="12" y1="22" x2="12" y2="8"/><path d="M5 12H2a10 10 0 0 0 20 0h-3"/></svg>',
      clean: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="4" y1="6" x2="20" y2="6"/><line x1="4" y1="12" x2="20" y2="12"/><line x1="4" y1="18" x2="20" y2="18"/></svg>',
      multipack: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>',
      warmth: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 2c1 4 5 5 5 10a5 5 0 0 1-10 0c0-3 2-4 2-6 1 1 2 2 3 2 0-2-1-4 0-6z"/></svg>',
      indoor: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 21h18M9 8h1M9 12h1M9 16h1M14 8h1M14 12h1M14 16h1M5 21V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16"/></svg>',
      cushion: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z"/></svg>',
      tag: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><circle cx="7" cy="7" r="1.5"/></svg>'
    };

    $$('.so-fc').forEach(function (fc) {
      var h3 = $('h3', fc);
      var icSpan = $('.so-fc-ic', fc);
      if (!h3 || !icSpan) return;
      var t = h3.textContent.trim().toLowerCase();
      var svg = $('svg', icSpan);
      var isCheckmark = svg && svg.innerHTML.indexOf('M5 12l4 4 10-10') !== -1;
      if (!isCheckmark && svg) return;

      var replacement = null;
      if (t.indexOf('reach') !== -1 || t.indexOf('staple') !== -1) replacement = ICONS.reach;
      else if (t.indexOf('everything') !== -1 || t.indexOf('versatil') !== -1) replacement = ICONS.versatile;
      else if (t.indexOf('layer') !== -1) replacement = ICONS.layer;
      else if (t.indexOf('effort') !== -1) replacement = ICONS.effortless;
      else if (t.indexOf('waistband') !== -1) replacement = ICONS.waistband;
      else if (t.indexOf('breathe') !== -1 || t.indexOf('air') !== -1) replacement = ICONS.breathe;
      else if (t.indexOf('gripping') !== -1 || t.indexOf('freedom') !== -1) replacement = ICONS.freedom;
      else if (t.indexOf('sleep') !== -1) replacement = ICONS.sleep;
      else if (t.indexOf('comfort') !== -1 || t.indexOf('all day') !== -1) replacement = ICONS.comfort;
      else if (t.indexOf('shoe') !== -1) replacement = ICONS.shoe;
      else if (t.indexOf('outfit') !== -1 || t.indexOf('finish') !== -1) replacement = ICONS.style;
      else if (t.indexOf('cheap') !== -1 || t.indexOf('cost') !== -1 || t.indexOf('value') !== -1) replacement = ICONS.value;
      else if (t.indexOf('stay') !== -1 || t.indexOf('stability') !== -1) replacement = ICONS.stability;
      else if (t.indexOf('under') !== -1 || t.indexOf('bunching') !== -1) replacement = ICONS.clean;
      else if (t.indexOf('stock') !== -1 || t.indexOf('pack') !== -1) replacement = ICONS.multipack;
      else if (t.indexOf('warmth') !== -1 || t.indexOf('bulk') !== -1) replacement = ICONS.warmth;
      else if (t.indexOf('indoor') !== -1 || t.indexOf('office') !== -1) replacement = ICONS.indoor;
      else if (t.indexOf('cushion') !== -1) replacement = ICONS.cushion;
      else replacement = ICONS.style;

      if (replacement) icSpan.innerHTML = replacement;
    });

    $$('.so-offerbox').forEach(function (box) {
      var svg = $('svg', box);
      if (svg && svg.innerHTML.indexOf('M5 12l4 4 10-10') !== -1) {
        svg.outerHTML = ICONS.tag;
      }
    });
  }

  // ------------------------------------------------------------ 7. Sticky Header on Scroll Up
  function initStickyHeaderOnScrollUp() {
    var lastY = window.scrollY;
    var header = $('.t4s-header__wrapper') || $('.so-header');
    if (!header) return;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if (y > 120 && y < lastY) {
        header.classList.add('is-sticky-header');
      } else if (y <= 60 || y > lastY) {
        header.classList.remove('is-sticky-header');
      }
      lastY = y;
    }, { passive: true });
  }

  // ------------------------------------------------------------ 8. Mobile Category Banner Framing
  function initCollectionBanners() {
    if (window.innerWidth > 767) return;
    var headings = $$('.so-split-heading');
    headings.forEach(function (h) {
      if (h.querySelector('.so-split-banner-frame')) return;
      var styleAttr = h.getAttribute('style') || '';
      var m = styleAttr.match(/url\(['"]?([^'"]+)['"]?\)/i) || (h.style.backgroundImage && h.style.backgroundImage.match(/url\(['"]?([^'"]+)['"]?\)/));
      if (!m) {
        var comp = window.getComputedStyle(h).backgroundImage;
        if (comp && comp !== 'none') m = comp.match(/url\(['"]?([^'"]+)['"]?\)/);
      }
      if (m && m[1]) {
        var frame = document.createElement('div');
        frame.className = 'so-split-banner-frame';
        frame.innerHTML = '<img src="' + m[1] + '" alt="Category Banner">';
        h.insertBefore(frame, h.firstChild);
      }
    });
  }

  // ------------------------------------------------------------ 9. Quick Filter Pill Rail
  function initQuickFilterPills() {
    var grid = $('[data-so-grid]');
    if (!grid) return;
    var rail = $('.so-quick-filter-rail');
    var toolbar = $('.t4s-collection-header');
    if (!rail && toolbar) {
      rail = document.createElement('div');
      rail.className = 'so-quick-filter-rail';
      var cards = $$('.t4s-product', grid);
      var pills = ['<button type="button" class="so-qf-pill is-active" data-qf-type="all">All</button>'];
      var isSocksPage = cards.length > 0 && cards.every(function (c) {
        var t = (c.querySelector('[data-so-pname]') || c.querySelector('.t4s-product-title'))?.textContent?.toLowerCase() || '';
        return t.indexOf('sock') !== -1 || (c.getAttribute('data-style') || '').toLowerCase().indexOf('sock') !== -1;
      });

      if (isSocksPage) {
        ['Ankle', 'Low show', 'Crew', 'No show'].forEach(function (l) {
          var count = cards.filter(function (c) { return (c.getAttribute('data-length') || '').toLowerCase() === l.toLowerCase(); }).length;
          if (count >= 2) pills.push('<button type="button" class="so-qf-pill" data-qf-type="length" data-qf-val="' + l + '">' + l + '</button>');
        });
        ['Pack of 2', 'Pack of 3'].forEach(function (pk) {
          var count = cards.filter(function (c) {
            var t = (c.querySelector('[data-so-pname]') || c.querySelector('.t4s-product-title'))?.textContent?.toLowerCase() || '';
            return (c.getAttribute('data-pack') || '').toLowerCase() === pk.toLowerCase() || t.indexOf(pk.toLowerCase()) !== -1;
          }).length;
          if (count >= 2) pills.push('<button type="button" class="so-qf-pill" data-qf-type="pack" data-qf-val="' + pk + '">' + pk + '</button>');
        });
        var cushCount = cards.filter(function (c) {
          var t = (c.querySelector('[data-so-pname]') || c.querySelector('.t4s-product-title'))?.textContent?.toLowerCase() || '';
          return c.getAttribute('data-cushioned') === 'true' || t.indexOf('cushion') !== -1;
        }).length;
        if (cushCount >= 2) pills.push('<button type="button" class="so-qf-pill" data-qf-type="cushion" data-qf-val="cushion">Cushioned</button>');
        ['Black', 'Grey', 'White', 'Blue'].forEach(function (col) {
          var count = cards.filter(function (c) { return (c.getAttribute('data-color') || '').toLowerCase().indexOf(col.toLowerCase()) !== -1; }).length;
          if (count >= 2) pills.push('<button type="button" class="so-qf-pill" data-qf-type="color" data-qf-val="' + col + '">' + col + '</button>');
        });
      } else {
        var stylesSeen = {};
        cards.forEach(function (c) {
          var st = c.getAttribute('data-style') || '';
          if (st && st !== 'Socks') stylesSeen[st] = (stylesSeen[st] || 0) + 1;
        });
        Object.keys(stylesSeen).forEach(function (st) {
          if (stylesSeen[st] >= 3) pills.push('<button type="button" class="so-qf-pill" data-qf-type="style" data-qf-val="' + st + '">' + st + '</button>');
        });
        ['Pack of 2', 'Pack of 3'].forEach(function (pk) {
          var count = cards.filter(function (c) {
            var t = (c.querySelector('[data-so-pname]') || c.querySelector('.t4s-product-title'))?.textContent?.toLowerCase() || '';
            return (c.getAttribute('data-pack') || '').toLowerCase() === pk.toLowerCase() || t.indexOf(pk.toLowerCase()) !== -1;
          }).length;
          if (count >= 2) pills.push('<button type="button" class="so-qf-pill" data-qf-type="pack" data-qf-val="' + pk + '">' + pk + '</button>');
        });
        ['S', 'M', 'L', 'XL', 'XXL'].forEach(function (sz) {
          var count = cards.filter(function (c) {
            return (c.getAttribute('data-sizes') || c.getAttribute('data-size') || '').split(',').some(function (s) { return s.trim().toUpperCase() === sz; });
          }).length;
          if (count >= 2) pills.push('<button type="button" class="so-qf-pill" data-qf-type="size" data-qf-val="' + sz + '">Size ' + sz + '</button>');
        });
        ['Black', 'Blue', 'White', 'Grey', 'Green'].forEach(function (col) {
          var count = cards.filter(function (c) { return (c.getAttribute('data-color') || '').toLowerCase().indexOf(col.toLowerCase()) !== -1; }).length;
          if (count >= 2) pills.push('<button type="button" class="so-qf-pill" data-qf-type="color" data-qf-val="' + col + '">' + col + '</button>');
        });
      }

      rail.innerHTML = pills.join('');
      toolbar.parentNode.insertBefore(rail, toolbar.nextSibling);
    }
    if (!rail || rail.__soInit) return;
    rail.__soInit = true;

    rail.addEventListener('click', function (e) {
      var pill = e.target.closest('.so-qf-pill');
      if (!pill) return;
      $$('.so-qf-pill', rail).forEach(function (p) { p.classList.remove('is-active'); });
      pill.classList.add('is-active');

      var type = pill.getAttribute('data-qf-type');
      var val = pill.getAttribute('data-qf-val');

      var cards = $$('.t4s-product', grid);
      cards.forEach(function (card) {
        if (type === 'all') {
          card.style.display = '';
          return;
        }
        var match = false;
        var pTitle = (card.querySelector('[data-so-pname]') || card.querySelector('.t4s-product-title'))?.textContent || '';
        var pTitleLower = pTitle.toLowerCase();

        if (type === 'length') {
          var cardLen = (card.getAttribute('data-length') || '').toLowerCase();
          match = cardLen === val.toLowerCase() || pTitleLower.indexOf(val.toLowerCase()) !== -1;
        } else if (type === 'pack') {
          var cardPack = (card.getAttribute('data-pack') || '').toLowerCase();
          match = cardPack === val.toLowerCase() || pTitleLower.indexOf(val.toLowerCase()) !== -1;
        } else if (type === 'cushion') {
          var isCush = card.getAttribute('data-cushioned') === 'true';
          match = isCush || pTitleLower.indexOf('cushion') !== -1;
        } else if (type === 'neck') {
          var cardNeck = (card.getAttribute('data-neck') || '').toLowerCase();
          match = cardNeck === val.toLowerCase() || pTitleLower.indexOf(val.toLowerCase()) !== -1;
        } else if (type === 'size') {
          var cardSizes = (card.getAttribute('data-sizes') || card.getAttribute('data-size') || '').split(',');
          match = cardSizes.some(function (s) { return s.trim().toUpperCase() === val.toUpperCase(); });
        } else if (type === 'color') {
          var cardColor = card.getAttribute('data-color') || '';
          match = cardColor.toLowerCase().indexOf(val.toLowerCase()) !== -1;
        } else if (type === 'style') {
          var cardStyle = card.getAttribute('data-style') || card.getAttribute('data-category') || '';
          match = cardStyle.toLowerCase().indexOf(val.toLowerCase()) !== -1;
        } else if (type === 'brand') {
          var cardBrand = card.getAttribute('data-brand') || '';
          match = cardBrand.toLowerCase().indexOf(val.toLowerCase()) !== -1;
        }
        card.style.display = match ? '' : 'none';
      });

      var visibleCount = cards.filter(function (c) { return c.style.display !== 'none' && !c.classList.contains('so-oos'); }).length;
      var countEl = $('#so-product-count');
      if (countEl) countEl.textContent = visibleCount + ' Products';
    });
  }

  // ------------------------------------------------------------ 10. Jockey Product Cards & Hover Auto-Scroll
  // Swap a card photo. Cards ship a srcset, and browsers render srcset over src,
  // so changing src alone leaves the old photo on screen.
  function setCardImg(img, url) {
    if (!img || !url) return;
    var b = url.split('?')[0];
    var set = b + '?width=360 360w, ' + b + '?width=533 533w, ' + b + '?width=720 720w';
    img.src = b + '?width=720';
    if (img.hasAttribute('srcset')) img.setAttribute('srcset', set);
    if (img.hasAttribute('data-src')) img.setAttribute('data-src', b + '?width=720');
    if (img.hasAttribute('data-srcset')) img.setAttribute('data-srcset', set);
  }

  // Card photo gallery: the card's photos sit in a scroll-snap track, so shoppers can
  // swipe through them on phones and use the arrows on desktop without opening the PDP.
  // Extra photos only start loading on the first interaction with that card.
  function inHScroller(el) {
    for (var p = el.parentElement; p && p !== document.body; p = p.parentElement) {
      var o = getComputedStyle(p).overflowX;
      if (o === 'auto' || o === 'scroll') return true;
    }
    return false;
  }

  function buildCardGallery(card, inner, mainImg, galleryImages, dotsBar) {
    var imgBox = mainImg.parentNode;
    if (!imgBox || card._soGal) return;
    var base0 = (mainImg.getAttribute('src') || '').split('?')[0];
    var extra = galleryImages.map(function (u) { return String(u).split('?')[0]; })
      .filter(function (u, k, arr) { return u && u !== base0 && arr.indexOf(u) === k; })
      .slice(0, 7);
    if (!extra.length) { if (dotsBar) dotsBar.style.display = 'none'; return; }

    var link = $('a.t4s-full-width-link', inner) || $('a[href*="/products/"]', card);
    var href = link ? link.getAttribute('href') : '';
    var track = document.createElement('div');
    track.className = 'so-cg-track';
    if (inHScroller(card)) card.classList.add('so-cg-inrail');

    function slide(child) {
      var s = document.createElement(href ? 'a' : 'div');
      s.className = 'so-cg-slide';
      if (href) { s.href = href; s.tabIndex = -1; }
      s.appendChild(child);
      track.appendChild(s);
      return s;
    }
    slide(mainImg);
    var lazy = extra.map(function (u) {
      var im = document.createElement('img');
      im.className = 'so-cg-img';
      im.alt = mainImg.alt || '';
      im.decoding = 'async';
      im.setAttribute('sizes', mainImg.getAttribute('sizes') || '(max-width: 767px) 50vw, 25vw');
      im.setAttribute('data-cg-src', u);
      slide(im);
      return im;
    });
    imgBox.appendChild(track);

    var hydrated = false;
    function hydrate() {
      if (hydrated) return;
      hydrated = true;
      lazy.forEach(function (im) {
        var b = im.getAttribute('data-cg-src');
        im.setAttribute('srcset', b + '?width=360 360w, ' + b + '?width=533 533w, ' + b + '?width=720 720w');
        im.src = b + '?width=720';
      });
    }

    var slides = $$('.so-cg-slide', track);
    if (dotsBar) {
      dotsBar.innerHTML = slides.map(function (_, i) {
        return '<span class="so-card-dot' + (i === 0 ? ' is-active' : '') + '"></span>';
      }).join('');
    }
    var prev = document.createElement('button');
    var next = document.createElement('button');
    prev.type = next.type = 'button';
    prev.className = 'so-cg-arrow so-cg-prev';
    next.className = 'so-cg-arrow so-cg-next';
    prev.setAttribute('aria-label', 'Previous photo');
    next.setAttribute('aria-label', 'Next photo');
    prev.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>';
    next.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>';
    inner.appendChild(prev);
    inner.appendChild(next);

    var cur = 0;
    function visible() { return slides.filter(function (s) { return s.style.display !== 'none'; }); }
    function sync() {
      var w = track.clientWidth || 1;
      cur = Math.round(track.scrollLeft / w);
      var n = visible().length;
      if (dotsBar) $$('.so-card-dot', dotsBar).forEach(function (d, k) { d.classList.toggle('is-active', k === cur); });
      prev.classList.toggle('is-off', cur <= 0);
      next.classList.toggle('is-off', cur >= n - 1);
    }
    function go(i) {
      hydrate();
      var n = visible().length;
      i = Math.max(0, Math.min(n - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(cur - 1); });
    next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(cur + 1); });
    var st;
    track.addEventListener('scroll', function () { hydrate(); clearTimeout(st); st = setTimeout(sync, 60); }, { passive: true });
    ['pointerenter', 'touchstart', 'focusin'].forEach(function (ev) {
      card.addEventListener(ev, hydrate, { passive: true, once: true });
    });
    sync();

    // A colour thumbnail was picked: the extra photos belong to the default colour, so
    // show only the picked colour's photo; picking the default colour brings them back.
    var defThumb = $('.so-var-thumb.is-active', card);
    var defColour = defThumb ? defThumb.getAttribute('data-color') : null;
    card._soGal = {
      colour: function (c, url) {
        var isDef = !defColour || c === defColour;
        if (isDef) setCardImg(mainImg, base0);
        else if (url) setCardImg(mainImg, url);
        slides.forEach(function (s, k) { if (k > 0) s.style.display = isDef ? '' : 'none'; });
        if (dotsBar) {
          $$('.so-card-dot', dotsBar).forEach(function (d, k) { if (k > 0) d.style.display = isDef ? '' : 'none'; });
          dotsBar.style.display = isDef ? '' : 'none';
        }
        prev.style.display = next.style.display = isDef ? '' : 'none';
        track.scrollLeft = 0;
        sync();
      }
    };
  }

  function initJockeyCards() {
    var cards = $$('.t4s-product');
    if (!cards.length) return;

    cards.forEach(function (card) {
      var inner = $('.t4s-product-inner', card);
      var mainImg = $('.t4s-product-main-img, .so-card-img', card);
      var info = $('.t4s-product-info', card);
      if (!inner || !mainImg) return;

      // Ensure main image does not clip socks/feet
      mainImg.style.objectPosition = 'center center';

      // 1. Gallery images for hover auto-scroll
      var galleryImages = [];
      var galleryAttr = card.getAttribute('data-gallery-images');
      if (galleryAttr) {
        try { galleryImages = JSON.parse(galleryAttr); } catch (e) {}
      }
      if (!galleryImages.length) {
        var seenUrls = {};
        if (mainImg.src) {
          var s0 = mainImg.src.split('?')[0];
          galleryImages.push(s0);
          seenUrls[s0] = true;
        }
        var swatches = $$('.t4s-pr-color__value, .so-var-thumb', card);
        swatches.forEach(function (sw) {
          var u = sw.getAttribute('data-img') || sw.getAttribute('data-image');
          if (u) {
            var clean = u.split('?')[0];
            if (!seenUrls[clean]) {
              galleryImages.push(clean);
              seenUrls[clean] = true;
            }
          }
        });
      }

      // 2. Dots container for hover progress
      var dotsBar = $('.so-card-dots-bar', inner);
      if (!dotsBar && galleryImages.length > 1) {
        dotsBar = document.createElement('div');
        dotsBar.className = 'so-card-dots-bar';
        dotsBar.innerHTML = galleryImages.map(function (_, i) {
          return '<span class="so-card-dot' + (i === 0 ? ' is-active' : '') + '"></span>';
        }).join('');
        inner.appendChild(dotsBar);
      } else if (dotsBar && galleryImages.length > 1 && !dotsBar.children.length) {
        dotsBar.innerHTML = galleryImages.map(function (_, i) {
          return '<span class="so-card-dot' + (i === 0 ? ' is-active' : '') + '"></span>';
        }).join('');
      }

      // 3. Swipeable photo gallery (swipe on touch, arrows on desktop hover)
      buildCardGallery(card, inner, mainImg, galleryImages, dotsBar);

      // 4. Upgrade card layout if bottom row is missing
      var bottomRow = $('.so-card-bottom-row', card);
      if (!bottomRow && info) {
        var priceEl = $('.t4s-product-price', card);
        var priceHtml = priceEl ? priceEl.innerHTML : '₹ 499.00';
        var handle = card.getAttribute('data-so-card') || card.getAttribute('data-so-rail-card') || '';

        var bRow = document.createElement('div');
        bRow.className = 'so-card-bottom-row';
        bRow.innerHTML = [
          '<div class="so-card-price-box">',
          priceHtml,
          '</div>',
          '<button type="button" class="so-card-atc-btn" data-action-addtobag data-handle="' + handle + '" aria-label="Add to bag">',
          '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">',
          '<path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>',
          '<line x1="3" y1="6" x2="21" y2="6"></line>',
          '<path d="M16 10a4 4 0 0 1-8 0"></path>',
          '</svg>',
          '<span>ADD TO BAG</span>',
          '</button>'
        ].join('');

        if (priceEl && priceEl.parentNode) {
          priceEl.parentNode.replaceChild(bRow, priceEl);
        } else {
          info.appendChild(bRow);
        }
      }

      // 5. Upgrade variation swatches into Jockey-style preview cards if old swatches exist
      var oldColors = $('.t4s-product-colors', card);
      if (oldColors && !$('.so-card-variations', card)) {
        var oldSwatches = $$('.t4s-pr-color__value', oldColors);
        if (oldSwatches.length > 0) {
          var varStrip = document.createElement('div');
          varStrip.className = 'so-card-variations';
          var thumbsHtml = [];
          oldSwatches.slice(0, 4).forEach(function (osw, idx) {
            var imgUrl = osw.getAttribute('data-img') || mainImg.src;
            var cName = osw.getAttribute('title') || '';
            thumbsHtml.push(
              '<button type="button" class="so-var-thumb' + (idx === 0 ? ' is-active' : '') + '" data-color="' + cName + '" data-img="' + imgUrl + '" title="' + cName + '">' +
              '<img src="' + imgUrl.split('?')[0] + '?width=80" alt="' + cName + '" loading="lazy">' +
              '</button>'
            );
          });
          if (oldSwatches.length > 4) {
            thumbsHtml.push('<span class="so-var-more">+' + (oldSwatches.length - 4) + ' More Colors</span>');
          }
          varStrip.innerHTML = thumbsHtml.join('');
          var infoInner = $('.t4s-product-info__inner', card) || info;
          infoInner.insertBefore(varStrip, infoInner.firstChild);
          oldColors.style.display = 'none';
        }
      }
    });
  }

  // ------------------------------------------------------------ Global ATC & Swatch Delegation
  document.addEventListener('click', function (e) {
    // 1. Variation thumbnail click
    var varThumb = e.target.closest('.so-var-thumb');
    if (varThumb) {
      e.preventDefault();
      var card = varThumb.closest('.t4s-product, [data-so-card], [data-so-rail-card]');
      if (!card) return;
      var parent = varThumb.closest('.so-card-variations');
      if (parent) {
        $$('.so-var-thumb', parent).forEach(function (t) { t.classList.remove('is-active'); });
      }
      varThumb.classList.add('is-active');
      var imgUrl = varThumb.getAttribute('data-img');
      var mainImg = card.querySelector('.t4s-product-main-img, .so-card-img');
      if (mainImg && imgUrl) {
        card.setAttribute('data-so-picked', '');
        card.dispatchEvent(new CustomEvent('so:colour'));
        if (card._soGal) card._soGal.colour(varThumb.getAttribute('data-color'), imgUrl);
        else setCardImg(mainImg, imgUrl);
      }
      // open the product page on the colour that was picked
      var pickedColour = varThumb.getAttribute('data-color');
      if (pickedColour) {
        $$('a[href*="/products/"]', card).forEach(function (a) {
          a.setAttribute('href', a.getAttribute('href').split('?')[0] + '?colour=' + encodeURIComponent(pickedColour));
        });
      }
      return;
    }

    // 2. ADD TO BAG button click on card
    var atcBtn = e.target.closest('.so-card-atc-btn, [data-action-addtobag]');
    if (atcBtn) {
      e.preventDefault();
      var card = atcBtn.closest('.t4s-product, [data-so-card], [data-so-rail-card]');
      if (!card) return;

      var handle = atcBtn.getAttribute('data-handle') || card.getAttribute('data-so-card') || card.getAttribute('data-so-rail-card');
      var title = (card.querySelector('[data-so-pname]') || card.querySelector('.t4s-product-title'))?.textContent.trim() || 'Product';
      var price = card.querySelector('.so-card-price, .t4s-price__sale, .t4s-product-price')?.textContent.trim().split('–')[0].trim() || '₹ 499.00';
      var imgEl = card.querySelector('.t4s-product-main-img, .so-card-img');
      var imgSrc = imgEl ? imgEl.src : '';
      var activeThumb = card.querySelector('.so-var-thumb.is-active');
      var colorName = activeThumb ? activeThumb.getAttribute('data-color') : '';

      // Check available sizes
      var sizesAttr = card.getAttribute('data-sizes') || card.getAttribute('data-size') || '';
      var sizes = sizesAttr ? sizesAttr.split(',').map(function (s) { return s.trim(); }).filter(Boolean) : [];

      if (!sizes.length || sizes.length === 1 || sizes[0].toUpperCase() === 'FS' || sizes[0].toLowerCase() === 'free size') {
        // Direct add to bag
        var chosenSize = sizes.length ? sizes[0] : 'Free Size';
        if (window.SO && window.SO.addToCart) {
          window.SO.addToCart({
            handle: handle,
            title: title,
            price: price,
            color: colorName,
            size: chosenSize,
            image: imgSrc,
            qty: 1
          });
        }
        atcBtn.classList.add('is-added');
        atcBtn.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg> <span>ADDED</span>';
        setTimeout(function () {
          atcBtn.classList.remove('is-added');
          atcBtn.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path></svg> <span>ADD TO BAG</span>';
        }, 1500);
      } else {
        // Open quick size selector popover
        var existingPopover = card.querySelector('.so-card-quick-sizes');
        if (existingPopover) {
          closeQuickSizes();
          return;
        }
        closeQuickSizes();

        // sizes struck through on the card are sold out
        var soldOut = {};
        $$('.so-card-sizes span span, .t4s-product-sizes span span', card).forEach(function (sp) {
          if (/line-through/.test(sp.getAttribute('style') || '')) soldOut[sp.textContent.trim().toUpperCase()] = true;
        });

        var pop = document.createElement('div');
        pop.className = 'so-card-quick-sizes';
        pop.setAttribute('role', 'dialog');
        pop.setAttribute('aria-label', 'Select size');
        pop.innerHTML = [
          '<div class="so-cqs-header">',
          '<span>Select size</span>',
          '<button type="button" class="so-cqs-close" aria-label="Close">&times;</button>',
          '</div>',
          '<div class="so-cqs-list">',
          sizes.map(function (s) {
            var out = soldOut[s.toUpperCase()];
            return '<button type="button" class="so-cqs-chip' + (out ? ' is-out' : '') + '" data-size="' + s + '"' +
              (out ? ' disabled aria-label="' + s + ' sold out"' : '') + '>' + s + '</button>';
          }).join(''),
          '</div>'
        ].join('');

        // open the picker right where the shopper tapped: over the card's own info area
        var infoInner = card.querySelector('.t4s-product-info') || card;
        infoInner.appendChild(pop);
        card.classList.add('so-cqs-open');
        var firstChip = pop.querySelector('.so-cqs-chip:not([disabled])');
        if (firstChip) firstChip.focus({ preventScroll: true });
        var pr = pop.getBoundingClientRect();
        if (pr.top < 70 || pr.bottom > window.innerHeight - 60) pop.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
      return;
    }

    // 3. Quick Size chip selection
    var sizeChip = e.target.closest('.so-cqs-chip');
    if (sizeChip) {
      e.preventDefault();
      var card = sizeChip.closest('.t4s-product, [data-so-card], [data-so-rail-card]');
      if (!card) return;
      var chosenSize = sizeChip.getAttribute('data-size');
      var handle = card.getAttribute('data-so-card') || card.getAttribute('data-so-rail-card') || '';
      var title = (card.querySelector('[data-so-pname]') || card.querySelector('.t4s-product-title'))?.textContent.trim() || 'Product';
      var price = card.querySelector('.so-card-price, .t4s-price__sale, .t4s-product-price')?.textContent.trim().split('–')[0].trim() || '₹ 499.00';
      var imgEl = card.querySelector('.t4s-product-main-img, .so-card-img');
      var imgSrc = imgEl ? imgEl.src : '';
      var activeThumb = card.querySelector('.so-var-thumb.is-active');
      var colorName = activeThumb ? activeThumb.getAttribute('data-color') : '';

      if (window.SO && window.SO.addToCart) {
        window.SO.addToCart({
          handle: handle,
          title: title,
          price: price,
          color: colorName,
          size: chosenSize,
          image: imgSrc,
          qty: 1
        });
      }

      var atcBtn = card.querySelector('.so-card-atc-btn');
      if (atcBtn) {
        atcBtn.classList.add('is-added');
        atcBtn.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg> <span>ADDED</span>';
        setTimeout(function () {
          atcBtn.classList.remove('is-added');
          atcBtn.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path></svg> <span>ADD TO BAG</span>';
        }, 1500);
      }

      closeQuickSizes();
      return;
    }

    // 4. Quick size close button
    var closeChip = e.target.closest('.so-cqs-close');
    if (closeChip) {
      e.preventDefault();
      closeQuickSizes();
      return;
    }

    // Close any open size popovers when clicking outside
    if (!e.target.closest('.so-card-quick-sizes') && !e.target.closest('.so-card-atc-btn')) {
      closeQuickSizes();
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeQuickSizes(); });

  function closeQuickSizes() {
    $$('.so-card-quick-sizes').forEach(function (p) { p.remove(); });
    $$('.so-cqs-open').forEach(function (c) { c.classList.remove('so-cqs-open'); });
  }

  // ------------------------------------------------------------ top announcement scroller (size S 60%, 9 Oct)
  // Fills the empty announcement-bar slot that every SO page ships; CSS reserves its height so nothing jumps.
  function initAnnBar() {
    var slot = $('#shopify-section-announcement-bar');
    if (!slot || slot.querySelector('.so-ann')) return;
    var msg = ['Up to 60% off size S', 'Applied automatically, no code needed', 'All styles · All brands', 'Innerwear to outerwear'];
    var item = msg.map(function (t) { return '<span class="so-ann-item">' + t + '</span>'; }).join('<span class="so-ann-dot" aria-hidden="true">·</span>') +
      '<span class="so-ann-dot" aria-hidden="true">·</span><span class="so-ann-item so-ann-cta">Shop size S &rarr;</span><span class="so-ann-dot" aria-hidden="true">·</span>';
    var run = item + item + item;
    slot.innerHTML = '<a class="so-ann" href="/collections/all?size=S" aria-label="Up to 60% off size S, applied automatically. Shop size S">' +
      '<span class="so-ann-track" aria-hidden="true"><span class="so-ann-run">' + run + '</span><span class="so-ann-run">' + run + '</span></span></a>';
  }

  // Homepage tiles / cards that open a collection land on its product grid (#so-shop), not on the
  // collection's banner (Amit, 10 Oct: "it displays the banner instead of the products").
  function initHomeTileLinks() {
    if (!$('[data-so-hero]')) return;
    $$('a[href^="/collections/"]').forEach(function (a) {
      if (a.closest('header, footer, .so-mega, .t4s-drawer, #shopify-section-announcement-bar, [data-so-chrome]')) return;
      var h = a.getAttribute('href');
      if (h.indexOf('#') === -1) a.setAttribute('href', h + '#so-shop');
    });
  }

  function init() {
    initAnnBar();
    initHomeTileLinks();
    initHero();
    initDragRows();
    initIconbar();
    initOffersRail();
    initPDP();
    initDelivery();
    WL.init();
    initCollectionSize();
    initVideoSpotlight();
    initFeatureIcons();
    initStickyHeaderOnScrollUp();
    initCollectionBanners();
    initQuickFilterPills();
    initJockeyCards();
  }
  // after preview.js's own DOMContentLoaded setup (filters, cart), which this builds on
  if (document.readyState === 'complete') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/* Category page: "Shop Now" scrolls to the products (Leo, 28 Sep 2026) */
document.addEventListener("click", function (e) {
  var cta = e.target.closest && e.target.closest(".so-hero-cta");
  if (!cta) return;
  var t = document.querySelector("#so-shop");
  if (t) { e.preventDefault(); t.scrollIntoView({ behavior: "smooth", block: "start" }); }
});
